/** @type {(value: string) => string} */
export const upperFirst = (value) => {
  if (!value || typeof value !== "string") {
    return value;
  }
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
};
